import React, { useState } from "react";
import { useAuth } from "../contexts/AuthContext";
import { useNavigate } from "react-router-dom";

const Login: React.FC = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const user = await login(email, password);
      const userRole = user.role;

      if (userRole === "admin") {
        navigate("/admin", { replace: true });
      } else if (userRole === "producer") {
        navigate("/my-bikes", { replace: true });
      } else if (userRole === "user") {
        navigate("/", { replace: true });
      } else {
        throw new Error("Konto istnieje, ale nie ma przypisanej roli (admin/producer/user).");
      }
    } catch (err: any) {
      console.error("Błąd logowania:", err);

      let errorMessage = "Login error. Check your data and try again.";
      if (err?.message) {
        errorMessage = err.message;
      }

      setError(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
        backgroundColor: "#0a192f",
        color: "#e6f1ff",
      }}
    >
      <div
        style={{
          width: "350px",
          padding: "30px",
          boxShadow: "0 10px 20px rgba(0,0,0,0.3)",
          borderRadius: "8px",
          backgroundColor: "#112240",
        }}
      >
        <h1 style={{ textAlign: "center", color: "#64ffda" }}>FIZMOOBASE</h1>
         <h3 style={{ textAlign: "center", marginBottom: "30px", color: "#ccd6f6" }}>
           Login
         </h3>

        {error && (
          <div style={{ color: "#ff6b6b", marginBottom: "15px", textAlign: "center" }}>{error}</div>
        )}

        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: "20px" }}>
             <label style={{ display: "block", marginBottom: "8px", color: "#8892b0" }}>
               Email:
             </label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              style={{
                width: "100%",
                padding: "12px",
                boxSizing: "border-box",
                backgroundColor: "#1e2d45",
                color: "#e6f1ff",
                border: "1px solid #3a506b",
                borderRadius: "4px",
              }}
            />
          </div>
          <div style={{ marginBottom: "25px" }}>
             <label style={{ display: "block", marginBottom: "8px", color: "#8892b0" }}>
               Password:
             </label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              style={{
                width: "100%",
                padding: "12px",
                boxSizing: "border-box",
                backgroundColor: "#1e2d45",
                color: "#e6f1ff",
                border: "1px solid #3a506b",
                borderRadius: "4px",
              }}
            />
          </div>
          <button
            type="submit"
            disabled={loading}
            style={{
              width: "100%",
              padding: "14px",
              backgroundColor: "#64ffda",
              color: "#0a192f",
              border: "none",
              borderRadius: "4px",
              cursor: loading ? "not-allowed" : "pointer",
              fontWeight: "bold",
              fontSize: "16px",
              transition: "background-color 0.3s",
            }}
          >
             {loading ? "Logging in..." : "Log in"}
          </button>
        </form>
        <div style={{ marginTop: "18px", textAlign: "center" }}>
           <a href="/producer-register" style={{ color: "#64ffda", textDecoration: "underline" }}>
             Don't have a producer account? Register
           </a>
        </div>
      </div>
    </div>
  );
};

export default Login;